import axios from 'axios';
import { Config } from '../config';
import { StructureDto, StructuresRequest } from '../model/structure.dto';

export class StructureApi {
    public async certificationList(accessToken: string, facilityNumber: string, applicant: string, sido: string, sigungu: string, location: string, phoneNumber: string, offset?:number, limit?:number): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/structure/certification`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const params = {
                structure_num: facilityNumber,
                applicant: applicant,
                sido: sido,
                sigungu: sigungu,
                address: location,
                phone_number: phoneNumber,
                offset: offset,
                limit: limit
            };
            const res = await axios.get(url, { headers, params });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async certificationAdd(accessToken: string, dto: StructureDto | null): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/structure/certification`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const res = await axios.post(url, dto, { headers });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async certificationsAdd(accessToken: string, list: StructuresRequest | null): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/structure/certification/list`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const res = await axios.post(url, list, { headers });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async putCertification(accessToken: string, dto: StructureDto): Promise<void> {
        try {
            const url = `${Config.API_URL}/console/structure/certification`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            await axios.put(url, dto, { headers });
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async delCertification(accessToken: string, checkItems: number[]): Promise<void> {
        try {
            const url = `${Config.API_URL}/console/structure/certification`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            await Promise.all(checkItems.map(async (id) => {
                const params = {
                    ids: id
                };    
                await axios.delete(url, { headers, params });
            }));
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async duplicateHits(accessToken: string, facilityNumber: string): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/structure/certification/check/${facilityNumber}`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const res = await axios.get(url, { headers });
            return res.data.result;
        } catch (error) {
            throw error;
        }
    }

    public async certificationSearch(accessToken: string, facilityNumber: string, applicant: string, sido: string, sigungu: string, location: string, phoneNumber: string): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/structure/certification`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const params = {
                structure_num: facilityNumber,
                applicant: applicant,
                sido: sido,
                sigungu: sigungu,
                address: location,
                phone_number: phoneNumber
            };
            const res = await axios.get(url, { headers, params });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}
